import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from "../../../core/_infrastructure/types/common";

export class SolicitudAtestFitoItemResultsViewModel extends PagingResultsViewModel {

    public ResultList: SolicitudAtestFitoItemViewModel[];
}

export class SolicitudAtestFitoItemViewModel {

    public Id: number;
    public RefAtestFito: string;
    public RefSolicitante: string;
    public FechaEnvio: Date | null;
    //public HoraEnvio: string;
    public TipoSolicitudAtestFito: string;
    public ComunidadAutonoma: string;
    public RazonSocial: string;
    public Provincia: string;
    public CodigoTipoSolicitud: string;
    public Estado: string;
    public PaisDestino: string;
    public UsuarioCa: string;
    public FechaValidezInicio: Date | null;
    public FechaValidezFin: Date | null;
    public FechaInspeccion: Date | null;
    public HoraInspeccion: string;
    public NombreTecResponsable: string;
    public IdTipoSolicitudInfCa: number;
    public IdEstado: number;
    public EsVisibleEdicion: boolean;
    
}

export class FilterSearchingSolicitudAtestFitoViewModel extends FilterSearchingBaseViewModel {

    firstDayMonth: Date;
    lastDayMonth: Date;

    constructor() {

        super();

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - (0.001 * 60 * 60 * 24));

        this.FechaRegistroDesde = this.firstDayMonth;
        this.FechaRegistroHasta = this.lastDayMonth;
    }


    public RefAtestFito: string = '';
    public FechaRegistroDesde: Date | null;
    public FechaRegistroHasta: Date | null;
    public FechaValidezDesde: Date | null;
    public FechaValidezHasta: Date | null;
    public FechaInspeccionDesde: Date | null;
    public FechaInspeccionHasta: Date | null;
    public IdTipoSolicitudInfCa: number | null;
    public IdCa: number | null;
    public IdProvincia: number | null;
    public IdEstado: number | null;
    public IdPaisDestino: number | null;
    public RazonSocial: string = '';
    public NombreTecResponsable: string = '';
    public IdUsuario: number = 0;
    public EsInspector: boolean;
    public EsCoordinador: boolean;
    public EsSolicitante: boolean;
    public EsComunidadAutonoma: boolean;
    public EsAgenteControl: boolean;
    public IdCaUsuarioCa: number | null;

}












